import { render } from "./MessageFlags.vue.js?vue&type=template&id=16ff2366&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=template&id=16ff2366&scoped=true"
import script from "./MessageFlags.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=script&lang=js"
export * from "./MessageFlags.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=script&lang=js"

import "./MessageFlags.vue.scss?vue&type=style&index=0&id=16ff2366&scoped=true&lang=scss!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=style&index=0&id=16ff2366&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ff2366"],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/MessageFlags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16ff2366"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16ff2366', __exports__)) {
    api.reload('16ff2366', __exports__)
  }
  
  module.hot.accept("./MessageFlags.vue.js?vue&type=template&id=16ff2366&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageFlags.vue?vue&type=template&id=16ff2366&scoped=true", () => {
    api.rerender('16ff2366', render)
  })

}


export default __exports__